export enum EtatHistoriqueMouvementEnum {
    NON_CONTROLE = 'page.declarations.historique-mouvements.table.header.etatType.nonControle',
    DECLARE = 'page.declarations.historique-mouvements.table.header.etatType.declare',
    EN_PRELEVEMENT = 'page.declarations.historique-mouvements.table.header.etatType.enPrelevement',
    PRELEVE = 'page.declarations.historique-mouvements.table.header.etatType.preleve',
    CONFORME = 'page.declarations.historique-mouvements.table.header.etatType.conforme',
    NON_CONFORME = 'page.declarations.historique-mouvements.table.header.etatType.nonConforme'
}
